export default "__VITE_ASSET__77f67fff__"